export default {
  SET_TOTAL_PRICE: 'SET_TOTAL_PRICE',
  SET_TOTAL_PRICE_FORMATTED: 'SET_TOTAL_PRICE_FORMATTED',
  SET_ITEM_PRICE: 'SET_ITEM_PRICE',
  SET_ITEM_PRICE_FORMATTED: 'SET_ITEM_PRICE_FORMATTED',
  SET_TOTAL_PACKAGING_PRICE: 'SET_TOTAL_PACKAGING_PRICE',
  SET_TOTAL_PACKAGING_PRICE_FORMATTED: 'SET_TOTAL_PACKAGING_PRICE_FORMATTED',
  SET_CART_GROUPS: 'SET_CART_GROUPS',
  SET_ORDER_DELIVERY_TYPE: 'SET_ORDER_DELIVERY_TYPE',
  SET_ORDER_PAYMENT_TYPES: 'SET_ORDER_PAYMENT_TYPES',
  SET_ORDER_PAYMENT_TYPE: 'SET_ORDER_PAYMENT_TYPE',
  SET_UPDATE_CART_URL: 'SET_UPDATE_CART_URL',
  SET_FIRSTNAME: 'SET_FIRSTNAME',
  SET_LASTNAME: 'SET_LASTNAME',
  SET_EMAIL: 'SET_EMAIL',
  SET_PHONE: 'SET_PHONE',
  SET_ADDRESS: 'SET_ADDRESS',
  SET_ERRORS: 'SET_ERRORS',
  SET_IS_VALID: 'SET_IS_VALID',
  SET_NOTE: 'SET_NOTE',
  SET_TOTAL_AMOUNT: 'SET_TOTAL_AMOUNT',
}
